import { render, staticRenderFns } from "./SeccionDeArticulos.vue?vue&type=template&id=595d0279&scoped=true&"
import script from "./SeccionDeArticulos.vue?vue&type=script&lang=js&"
export * from "./SeccionDeArticulos.vue?vue&type=script&lang=js&"
import style0 from "./SeccionDeArticulos.vue?vue&type=style&index=0&id=595d0279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d0279",
  null
  
)

export default component.exports